<template>
    <div class="basic_wrap">
        <div class="detail_img">
            <div class="back_left" @click="$router.back()"></div>
            <!-- <div class="video_box" v-show='false'>
                <div class="video_icon"></div>
                <img src="../images/index/test2.png" alt="">
			</div> -->
            <div class="loop_box">
                <img :src="data.img" alt="">
            </div>
            <!-- <div class="cut_box">
                <div class="video_btn cur"></div>
                <div class="pic_btn"></div>
			</div> -->
            <!-- <div class="loop_num">1/5</div> -->
        </div>
        <div class="item_detail">
            <h2 class="shop_name">{{data.title}}</h2>
            <p class="merchant_name" v-if="data.merchant_name">{{data.merchant_name}}</p>
            <div class="shop_price">
                <div class="new_icon" v-if="data.num == 1"></div>
                <div class="now_price">¥<span>{{$parent.numFilter(showPrice(data))}}</span></div>
            </div>
            <div class="s_num">
                <div class="sale_num">剩余库存：{{data.stock || 0}}</div>
                <div class="sale_num">销量：{{parseInt(data.sales_base || 0)}}</div>
                <div class="limit" v-if="data.num == '1'">限购：每人1单</div>
            </div>
        </div>
        <div class="active_box">
            <div class="active_tit">商品参数</div>
            <div class="active_type info_grid">
                <div class="item_type">
                    <div class="type_name"><span class="name_inner">商家</span></div>
                    <div class="sale_status">{{data.merchant_name || '平台自营'}}</div>
                </div>
                <div class="item_type">
                    <div class="type_name"><span class="name_inner">售价</span></div>
                    <div class="sale_status">¥{{showPrice(data)}}</div>
                </div>
                <div class="item_type">
                    <div class="type_name"><span class="name_inner">库存</span></div>
                    <div class="sale_status">{{data.stock || 0}} 件</div>
                </div>
            </div>
        </div>
        <div class="merchant_box" v-if="merchantItems.length">
            <div class="merchant_head">
                <div class="merchant_info">
                    <img class="merchant_logo" :src="merchantLogo" alt="">
                    <div class="merchant_text">
                        <div class="merchant_topline">
                            <span class="merchant_title">{{data.merchant_name || '品牌旗舰店'}}</span>
                            <span class="merchant_tag">自营</span>
                        </div>
                        <div class="merchant_star">★★★★★</div>
                    </div>
                </div>
                <div class="merchant_enter" @click="goMerchantShop">进店</div>
            </div>
            <div class="merchant_goods">
                <div class="merchant_good" v-for="item in merchantItems" :key="item.id" @click="$router.push('/details/' + item.id)">
                    <img :src="item.img" alt="">
                    <p class="van-multi-ellipsis--l2">{{item.title}}</p>
                    <div class="merchant_price">¥{{showPrice(item)}}</div>
                </div>
            </div>
        </div>
        <div class="invest_box">
            <h3 class="invest_tit">商品说明</h3>
            <div class="invest_item">
                <div
                    v-if="detailContent"
                    class="invest_content intro_text rich_text_content"
                    v-html="detailContent"
                ></div>
                <div v-else class="invest_content intro_text">暂无商品说明</div>
            </div>
        </div>
        <div class="item_sk" v-if="!data.status">该商品已下架</div>
        <div class="buy_box" :class="{'no_kefu': !showKefu}">
            <!-- 在线客服入口暂时隐藏：showKefu 改为 true 即可恢复 -->
            <div class="custom" v-if="showKefu" @click="$router.push('/kefu')">
                <i></i>
                <span>咨询客服</span>
            </div>
            <div class="cart_go" @click="$router.push('/cart')">
                <i><span v-if="catNum != 0">{{catNum < 10 ? catNum : 9}}</span></i>
                <span>购物车</span>
            </div>
			<div class="add_cart" v-if="data.status && data.num > 1" @click="show_shop('cart')"></div>
			<div class="buy_btn" :class="data.num == 1?'newPoeple':''" @click="show_shop('buy')" v-html="data.num == 1?'立即购买':''" v-if="data.status"></div>
            
        </div>
    </div>
</template>

<script>
    import Fetch from '../../utils/fetch';

    export default {
        name: "login",
        data() {
            return {
                data: {},
                merchantItems: [],
                catNum: 0,
                // 在线客服入口开关：false=隐藏，true=显示
                showKefu: false
            };
        },
        created() {
            this.$parent.footer('item', false);
        },
        mounted() {
            this.start();
        },
        watch: {
            $route() {
                // 详情页内点击同店商品等场景：路由参数变化时组件被复用，需重新加载数据。
                // 原 $router.go(0) 整页刷新在部分移动端 WebView 中不生效，导致主图残留上一商品。
                this.start();
            }
        },
        methods: {
            showPrice(item) {
                var price = parseFloat(item.price);
                if (isNaN(price) || price <= 0) {
                    price = parseFloat(item.min) || 0;
                }
                return price.toFixed(2);
            },
            start() {
                // 先清空旧数据，避免切换商品瞬间仍显示上一商品的图片/标题
                this.data = {};
                this.merchantItems = [];
                Fetch('/shop/item_view', {
                    id: this.$route.params.id
                }).then((r) => {
                    this.data = r.data;
                    this.loadMerchantItems();
                });
                this.catNumHandle();
            },
            loadMerchantItems() {
                if (!this.data.merchant_id) {
                    this.merchantItems = [];
                    return;
                }
                Fetch('/shop/items', {
                    merchant_id: this.data.merchant_id,
                    page: 1,
                    page_size: 7
                }).then((r) => {
                    var currentId = parseInt(this.data.id) || 0;
                    var list = (r.data.list || []).filter(item => parseInt(item.id) !== currentId);
                    this.merchantItems = list.slice(0, 6);
                }).catch(() => {
                    this.merchantItems = [];
                });
            },
            goMerchantShop() {
                if (!this.data.merchant_id) return;
                this.$router.push({
                    path: '/type',
                    query: {
                        merchant_id: this.data.merchant_id,
                        type1: this.data.merchant_name || '品牌好店'
                    }
                });
            },
            catNumHandle() {
                Fetch('/user/cart', {}, {
                    method: 'get'
                }).then((r) => {
                    this.catNum = r.data.list.length;
                });
            },
            show_shop(str) {
                if (!this.data.status) {
                    this.$toast('商品已下架');
                    return;
                }
                if (this.data.stock <= 0) {
                    this.$toast('库存不足');
                    return;
                }
                if (str == 'cart') {
                    // 加购（只能一个一个买，数量固定为1）
                    Fetch('/user/cart_add', {
                        item_id: this.data.id,
                        num: 1
                    }).then(r => {
                        this.$toast('已加入购物车');
                        this.catNumHandle();
                    })
                } else {
                    // 立即购买（只能一个一个买，数量固定为1）
                    var items = [];
                    items.push({
                        item_id: this.data.id,
                        num: 1,
                    })
                    localStorage.setItem('cart', JSON.stringify(items));
                    this.$router.push('/confirm');
                }
            },
        },
        computed: {
            detailContent() {
                return this.data.fixedcontent || this.data.desc || '';
            },
            merchantLogo() {
                return this.data.merchant_logo || this.data.img || '';
            }
        }
    };
</script>

<style lang="less" scoped>
    /deep/ .active_type {
        margin: 0;
    }
    .notouch{
        pointer-events: none;
    }
    .item_sk{
        width: 10rem;
        height: 35px;
        line-height: 35px;
        background: #FDFADB;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #C9793F;
        font-size: 12px;
        position: fixed;
        z-index: 10;
        left: 50%;
        bottom: 52px;
        transform: translateX(-50%);
    }
    .buy_box .buy_btn.newPoeple {
        margin-left: auto;
        width: 150px;
        background: #FFB700;
        color: #FFFFFF;
        line-height: 35px;
        font-size: 14px;
        text-align: center;
        border-radius: 18px;
    }

    .new_icon {
        width: 55px;
        height: 19px;
        background: url(../images/index/news.png) no-repeat center center;
        background-size: 100% 100%;
        margin-right: 8px;
    }

    .detail_img {
        width: 375px;
        height: 375px;
        position: relative;

        .back_left {
            width: 30px;
            height: 30px;
            position: absolute;
            top: 25px;
            left: 5px;
            background: url(../images/detail/back.png) no-repeat center center;
            background-size: 100% 100%;
            z-index: 5;
        }

        .video_box,
        .loop_box {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;

            img,
            video {
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
                z-index: 1;
            }

            .video_icon {
                width: 61px;
                height: 61px;
                position: absolute;
                top: 50%;
                left: 50%;
                margin-top: -30px;
                margin-left: -30px;
                background: url(../images/detail/play.png) no-repeat center center;
                background-size: 100% 100%;
                z-index: 2;

                &.play {
                    background: url(../images/detail/sus.png) no-repeat center center;
                    background-size: 100% 100%;
                }
            }
        }

        .cut_box {
            width: 100%;
            position: absolute;
            height: 20px;
            left: 0;
            bottom: 10px;
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 4;

            .video_btn {
                width: 48px;
                height: 100%;
                background: url(../images/detail/video.png) no-repeat center center;
                background-size: 100% 100%;
                margin: 0 6px;

                &.cur {
                    background: url(../images/detail/video_cur.png) no-repeat center center;
                    background-size: 100% 100%;
                }
            }

            .pic_btn {
                width: 48px;
                height: 100%;
                background: url(../images/detail/pic.png) no-repeat center center;
                background-size: 100% 100%;
                margin: 0 6px;

                &.cur {
                    background: url(../images/detail/pic_cur.png) no-repeat center center;
                    background-size: 100% 100%;
                }
            }
        }

        .loop_num {
            position: absolute;
            bottom: 10px;
            right: 16px;
            z-index: 5;
            height: 20px;
            display: flex;
            align-items: center;
            background: rgba(0, 0, 0, 0.3);
            font-size: 12px;
            text-align: center;
            color: #FFFFFF;
            border-radius: 10px;
            padding: 0 9px;
        }
    }

    .kill_slae {
        width: 100%;
        height: 46px;
        background: url(../images/detail/ms.png) no-repeat center center;
        background-size: 100% 100%;
        position: relative;

        .now_price {
            position: absolute;
            font-size: 14px;
            color: #FB2004;
            height: 30px;
            line-height: 30px;
            top: 13px;
            left: 107px;
            font-weight: 600;

            span {
                font-size: 28px;
            }
        }

        .old_price {
            position: absolute;
            font-size: 14px;
            color: #FFFFFF;
            height: 16px;
            line-height: 16px;
            top: 26px;
            left: 262px;
            text-decoration: line-through;
        }
    }

    .item_detail {
        width: 100%;
        padding: 16px 16px 20px 16px;
        box-shadow: 0px 2px 9px 2px rgba(160, 160, 160, 0.15);
        border-radius: 0 0 6px 6px;
        background-color: #FFFFFF;

        .shop_name {
            font-size: 16px;
            font-weight: bold;
            color: rgba(0,0,0,.8);
            line-height: 22px;
        }

        .merchant_name {
            font-size: 12px;
            color: rgba(0,0,0,.5);
            margin-top: 4px;
        }

        .shop_price {
            height: 28px;
            margin-top: 12px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            .fxmoney, .recycle_price {
                font-size: 12px;
                color: #07c160;
                margin-left: 10px;
                margin-top: 10px;
			}
            .now_price {
                font-size: 14px;
                color: #FB2004;
                height: 28px;
                line-height: 28px;
                font-weight: 600;

                span {
                    font-size: 26px;
                }
            }

            .old_price {
                font-size: 14px;
                color: #B3B3B3;
                height: 16px;
                line-height: 16px;
                text-decoration: line-through;
                margin-left: 10px;
                margin-top: 7px;
            }
        }
        .s_num.discount_num .sale_num{
            color: #f12211;
            font-size: 14px;
            font-weight: bold;
        }
        .s_num {
            height: 20px;
            margin-top: 11px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .sale_num {
                height: 17px;
                line-height: 17px;
                font-size: 12px;
                color: rgba(0,0,0,.6);
            }
        }
    }

    .active_box {
        width: 100%;
        padding: 18px 16px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 2px 9px 2px rgba(160, 160, 160, 0.15);
        border-radius: 6px;
        margin-top: 12px;
        display: flex;
        justify-content: flex-start;

        .active_tit {
            width: 60px;
            font-weight: bold;
            color: rgba(0,0,0,.8);
            height: 16px;
            font-size: 14px;
            line-height: 16px;
        }

        .active_type {
            flex: 1;
            font-size: 12px;

            .item_type {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                margin-top: 13px;

                &:first-child {
                    margin-top: 0;
                }

                .type_name {
                    height: 16px;
                    line-height: 16px;
                    width: 50px;

                    .name_inner {
                        background: rgba(241, 34, 17, 0.08);
                        border-radius: 4px;
                        color: #f12211;
                        padding: 0 3px;
                        text-align: center;
                        float: left;
                    }
                }

                .sale_status {
                    color: rgba(0,0,0,.8);
                    line-height: 17px;
                    margin-left: 3px;
                }
            }
        }
    }

    .invest_box {
        width: 375px;
        margin-top: 12px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 2px 9px 2px rgba(160, 160, 160, 0.15);
        border-radius: 6px;
        padding: 20px 16px;
        line-height: 17px;
        font-size: 12px;
        color: rgba(0,0,0,.8);

        .invest_tit {
            height: 14px;
            font-size: 14px;
            font-weight: bold;
        }

        .invest_item {
            display: flex;
            justify-content: flex-start;
            margin-top: 12px;

            &.align_50 {
                .describe {
                    flex: 1.5;
                }

                .invest_content {
                    flex: 1;
                }
            }

            &.text_right {
                .invest_content {
                    text-align: right;
                }
            }

            &.origin_font {
                .invest_content {
                    color: #FB2004;
                }
            }

            .describe {
                width: 90px;
            }

            .invest_content {
                flex: 1;
                line-height: 17px;
            }
        }

        /deep/ .rich_text_content {
            line-height: 1.7;
            word-break: break-word;
        }

        /deep/ .rich_text_content img {
            max-width: 100%;
            height: auto !important;
        }

        /deep/ .rich_text_content p,
        /deep/ .rich_text_content div,
        /deep/ .rich_text_content span {
            max-width: 100%;
        }
    }

    .merchant_box {
        width: 375px;
        margin-top: 12px;
        background: #FFFFFF;
        box-shadow: 0px 2px 9px 2px rgba(160, 160, 160, 0.15);
        border-radius: 10px;
        padding: 16px;

        .merchant_head {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .merchant_info {
            display: flex;
            align-items: center;
            flex: 1;
            min-width: 0;
        }

        .merchant_logo {
            width: 42px;
            height: 42px;
            border-radius: 50%;
            border: 1px solid #F0F0F0;
            flex-shrink: 0;
            object-fit: cover;
            background: #FFFFFF;
        }

        .merchant_text {
            margin-left: 10px;
            min-width: 0;
        }

        .merchant_topline {
            display: flex;
            align-items: center;
        }

        .merchant_title {
            font-size: 16px;
            font-weight: bold;
            color: rgba(0,0,0,.85);
            max-width: 180px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }

        .merchant_tag {
            margin-left: 8px;
            padding: 0 6px;
            height: 18px;
            line-height: 18px;
            border-radius: 9px;
            background: #FF5C2A;
            color: #FFFFFF;
            font-size: 11px;
        }

        .merchant_star {
            margin-top: 4px;
            color: #FF7A00;
            font-size: 13px;
            letter-spacing: 1px;
        }

        .merchant_enter {
            min-width: 54px;
            height: 28px;
            line-height: 28px;
            text-align: center;
            border-radius: 14px;
            background: linear-gradient(123deg,#e3382e,#ff7a2f);
            color: #FFFFFF;
            font-size: 12px;
        }

        .merchant_goods {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            grid-column-gap: 14px;
            grid-row-gap: 18px;
            margin-top: 16px;
        }

        .merchant_good {
            min-width: 0;

            img {
                width: 100%;
                aspect-ratio: 1 / 1;
                border-radius: 8px;
                object-fit: cover;
                border: 1px solid #F4F4F4;
                background: #FFFFFF;
            }

            p {
                margin-top: 8px;
                min-height: 34px;
                line-height: 17px;
                font-size: 12px;
                color: rgba(0,0,0,.75);
            }

            .merchant_price {
                margin-top: 4px;
                font-size: 13px;
                color: #E3382E;
                font-weight: bold;
                line-height: 18px;
            }
        }
    }

    .buy_box {
        width: 375px;
        height: 52px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
        display: flex;
        align-items: center;
        position: fixed;
        z-index: 10;
        left: 50%;
        bottom: 0;
        padding: 0 12px;
        transform: translateX(-50%);

        .custom {
            margin-left: 20px;
        }

        /* 无客服按钮时：购物车无左间距，加购/立即购买推到最右侧 */
        &.no_kefu .cart_go {
            margin-left: 0;
        }
        &.no_kefu .add_cart {
            margin-left: auto;
        }

        .cart_go {
            margin-left: 30px;
            position: relative;

            i span {
                position: absolute;
                width: 14px;
                height: 14px;
                border: 1px solid #f12211;
                border-radius: 50%;
                line-height: 14px;
                font-size: 12px;
                top: 0;
                right: 10px;
                background-color: #FFFFFF;
                transform: scale(0.7);
                color: #f12211;
                font-style: normal;
            }
        }

        .custom,
        .cart_go {
            width: 40px;
            height: 36px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;

            span {
                font-weight: 400;
                color: rgba(74, 74, 74, 1);
                line-height: 14px;
                font-size: 12px;
                width: 60px;
                transform: scale(0.85);
                text-align: center;
            }
        }

        .custom i {
            width: 22px;
            height: 22px;
            background: url(../images/detail/kf.png) no-repeat center center;
            background-size: 100% 100%;
        }

        .cart_go i {
            width: 22px;
            height: 22px;
            background: url(../images/detail/cart.png) no-repeat center center;
            background-size: 100% 100%;
        }

        .add_cart {
            width: 94px;
            height: 35px;
            background: url(../images/detail/jg.png) no-repeat center center;
            background-size: 100% 100%;
            margin-left: 24px;
        }

        .buy_btn {
            width: 94px;
            height: 35px;
            background: url(../images/detail/buy.png) no-repeat center center;
            background-size: 100% 100%;
            margin-left: 10px;
        }
		
		.sale_time {
		    width: 200px;
		    height: 35px;
			line-height: 35px;
		    background: linear-gradient(123deg,#e3382e,#ff4d15);
			color: #ffffff;
		    margin-left: 15px;
			border-radius: 18px;
			text-align: center;
			font-size: 14px;
			.van-count-down{
				display: inline;
				line-height: 35px;
				color: #ffffff;
				font-size: 14px;
			}
		}
    }

    .vip_price {
        width: 100%;
        height: 47px;
        background: linear-gradient(270deg, rgba(76, 64, 65, 1) 0%, rgba(72, 59, 61, 1) 100%);
        border-radius: 0px 0px 6px 6px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 16px;

        .vip_num {
            height: 33px;
            font-size: 24px;
            font-weight: 500;
            color: rgba(221, 206, 185, 1);
            line-height: 33px;
        }

        .vip_discount {
            height: 17px;
            font-size: 12px;
            font-weight: 400;
            color: rgba(224, 213, 207, 1);
            line-height: 17px;
        }
    }
</style>
